import { render, staticRenderFns } from "./CopyLinkInput.vue?vue&type=template&id=1af424ce&scoped=true"
import script from "./CopyLinkInput.vue?vue&type=script&lang=js"
export * from "./CopyLinkInput.vue?vue&type=script&lang=js"
import style0 from "./CopyLinkInput.vue?vue&type=style&index=0&id=1af424ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af424ce",
  null
  
)

export default component.exports